export const campaigns = {
   summer23: {
      id: `summer23`,
      name: `Summer 2023`,
      startDate: `2023-08-15`,
      endDate: `2023-09-14`,
      description: `A campaign that takes place in the summer of 2023.`,
      link: `/checkout?planId=804163&coupon=SUMMER25`,
   },

   fall23: {
      id: `fall23`,
      name: `Fall Saving`,
      startDate: `2023-09-15`,
      endDate: `2023-10-14`,
      description: `A campaign that takes place in the fall of 2023.`,
      link: `https://premast.com/deals/fall2023`,
   },
};
